/**
 * `kind: 'wager'`. Bounds are the spec's (set in `games/src/jeopardy/requests.ts`) so
 * they can't disagree with core's check.
 */

import { useState } from 'react';
import type { InputSpec } from '@gsf/contract';
import type { RendererProps } from '../renderer';

/** Spinner step only; core doesn't check divisibility, so 137 is a legal wager. */
const STEP = 5;

export function WagerInput({
  request,
  spec,
  submit,
  disabled,
}: RendererProps<Extract<InputSpec, { kind: 'wager' }>>) {
  // Opens on the maximum: a Daily Double is usually an all-in.
  const [amount, setAmount] = useState(String(spec.max));

  return (
    <>
      <p className="play-hint">
        {request.prompt}{' '}
        <span className="faint">
          Between {spec.min} and {spec.max}.
        </span>
      </p>
      <form
        className="play-answer-form"
        onSubmit={(event) => {
          event.preventDefault();
          submit(Number(amount));
        }}
      >
        <input
          type="number"
          inputMode="numeric"
          min={spec.min}
          max={spec.max}
          step={STEP}
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
          disabled={disabled}
          style={{ fontSize: '1.6rem', textAlign: 'center' }}
        />
        <button className="btn btn-primary btn-lg" type="submit" disabled={disabled}>
          Lock in wager
        </button>
      </form>
    </>
  );
}
